import gql from "graphql-tag";

const noteMutations = {


    createNote: gql`
        mutation CreateNote($deleted_at: DateTime, $created_at: DateTime, $updated_at: DateTime, $creator_id: Int, $content: String) {
            createNote(deleted_at: $deleted_at, created_at: $created_at, updated_at: $updated_at, creator_id: $creator_id, content: $content) {
                id,
                deleted_at,
                created_at,
                updated_at,
                creator_id,
                content
            }
        }
    `,
    updateNote: gql`
        mutation UpdateNote($id: ID!, $deleted_at: DateTime, $created_at: DateTime, $updated_at: DateTime, $creator_id: Int, $content: String) {
            updateNote(id: $id, deleted_at: $deleted_at, created_at: $created_at, updated_at: $updated_at, creator_id: $creator_id, content: $content) {
                id,
                deleted_at,
                created_at,
                updated_at,
                creator_id,
                content
            }
        }
    `,
};

export default noteMutations;